export const trackPageview = () => {
  if (typeof window !== "undefined" && window.plausible) {
    window.plausible("pageview");
  }
};

export const trackEvent = (eventName) => {
  if (typeof window !== "undefined" && window.plausible) {
    window.plausible(eventName);
  }
};
